import { createSlice, createAction } from '@reduxjs/toolkit';

export const fetchProductCategoryRequest = createAction('category/fetchRequest');
export const fetchProductCategorySuccess = createAction('category/fetchSuccess');
export const fetchProductCategoryFailure = createAction('category/fetchFailure');

const initialState = {
  loading: false,
  error: null,
  categoryData: null,
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductCategoryRequest, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductCategorySuccess, (state, action) => {
        state.loading = false;
        state.categoryData = action.payload;
      })
      .addCase(fetchProductCategoryFailure, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default categorySlice.reducer;
